const config = {
  // BASE_URL: process.env.REACT_APP_ISDEV
  //   ? 'https://simpeldesapi.loginusa.id/main/'
  //   : 'https://api.desapedia.co.id/main/',
  BASE_URL_FILE:
    process.env.REACT_APP_ISDEV === "true"
      ? "https://devapigateway.desapedia.co.id/v1/fileapi/"
      : "https://apigateway.desapedia.co.id/v1/fileapi/",
  BASE_URL:
    process.env.REACT_APP_ISDEV === "true"
      ? "https://devapigateway.desapedia.co.id/v1/main/"
      : "https://apigateway.desapedia.co.id/v1/main/",

  BASE_URL_FORM_DINAMIS:
    process.env.REACT_APP_ISDEV === "true"
      ? "https://devapigateway.desapedia.co.id/v1/dynamicformapi/"
      : "https://apigateway.desapedia.co.id/v1/dynamicformapi/",
};

export { config };
